import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STATS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getSalesSummaryAction = createAsyncThunk(
    'stats/getSalesSummaryAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ STATS_PATH }/summary${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getSalesSummarySlice = createSlice({
    name: 'getSalesSummarySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getSalesSummaryAction.pending, () => STATE__API__STARTED);
        builder.addCase(getSalesSummaryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getSalesSummaryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getSalesSummaryState = (state) => state.stats.getSalesSummary;
export default getSalesSummarySlice.reducer;
